// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"14b02d52","132":"cebfe8f9","248":"005281be","399":"220ad1d7"}[chunkId] + ".chunk.js";
};